<script setup>
import {ref} from 'vue'
import CustomMask from "@/components/NewPC/CustomMask.vue";
const MaskRef = ref(null);

const open = () => {
  MaskRef.value?.open()
}

defineExpose({open})

</script>

<template>
<custom-mask ref="MaskRef">
  <template v-slot:default>
    <div class="content">
      <img src="@/assets/newPc/close_icon.png" alt="" class="close_icon" @click="open" />
      <div>扫码添加官方企业微信</div>
      <img class="arrows" src="@/assets/newPc/contact_arrows_icon.png" alt="">
      <img class="qrcode_icon" src="@/assets/newPc/qrcode.png" alt="">
      <div>客服QQ：2145214945</div>
    </div>
  </template>
</custom-mask>
</template>

<style scoped lang="scss">
.content {
  width: 15.4296875vw;
  height: 19.375vw;
  background: transparent url("@/assets/newPc/contact_us_bg.png") no-repeat center center;
  background-size: contain;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  font-family: 'SourceHanSansCN-Regular';
  font-size: 0.9375vw;
  color: #A9AED0;

  .qrcode_icon {
    padding: 2px;
    background: #6666C3;
    width: 5.6640625vw;
    height: 5.6640625vw;
    margin-top: 6px;
    margin-bottom: 20px;
  }

  .arrows {
    width: 2.109375vw;
    height: 0.859375vw;
  }

  .close_icon {
    width: 1.6015625vw;
    height: 1.6015625vw;
    position: absolute;
    right: 0.703125vw;
    top: 0.703125vw;
    cursor: pointer;
  }
}
</style>